import { spData } from '../data/sp-data'
import store from '../store/index'
import Bus from '../utils/bus'

// 从服务端获取到的数据
export default class SocketService {
  /**
   * 单例
   */
  static instance = null
  static get Instance () {
    if (!this.instance) {
      this.instance = new SocketService()
    }
    return this.instance
  }
  // 和服务端连接的socket对象
  ws = null
  allData = {}
  // websoket地址
  wsUrl = `ws://${location.host}/wsUrl`

  // 存储回调函数
  callBackMapping = {}

  // 标识是否连接成功
  connected = false

  // 记录重试的次数
  sendRetryCount = 0

  // 重新连接尝试的次数
  connectRetryCount = 0
  //  定义连接服务器的方法
  connect () {
    // 连接服务器
    if (!window.WebSocket) {
      return console.log('您的浏览器不支持WebSocket')
    }
    //运维演示环境
    // this.ws = new WebSocket('wss://cssp-scr.snca.com.cn/decorate')
    //研发部测试环境
    // this.ws = new WebSocket('ws://10.10.60.21:9084/decorate')
    this.ws = new WebSocket(this.wsUrl)
    this.ws.onopen = () => {
      console.log('连接服务端成功了')
      this.connected = true
      // 重置重新连接的次数
      this.connectRetryCount = 0
    }
    // 1.连接服务端失败
    // 2.当连接成功之后, 服务器关闭的情况
    this.ws.onclose = () => {
      console.log('连接服务端失败')
      if (localStorage.getItem('WebSocketData')) {
        Bus.$emit("updateData")
      }
      this.connected = false
      this.connectRetryCount++
      setTimeout(() => {
        this.connect()
      }, 500 * this.connectRetryCount)
    }
    // 得到服务端发送过来的数据
    this.ws.onmessage = msg => {
      console.log('从服务端获取到了数据')
      // 真正服务端发送过来的原始数据时在msg中的data字段
      // const recvData = spData
      const recvData = JSON.parse(msg.data)
      this.allData = recvData
      let obj = {}

      recvData.list.forEach((item, index) => {
        obj[item.name] = item
        store.commit('saveWebSocketData', obj)
        //TODO：测试完打开注释
        // localStorage.setItem('WebSocketData', JSON.stringify(obj))
        // if (Object.keys(obj).length>0) {
        //   Bus.$emit("updateData", obj)
        // }
      })
      //TODO：测试完注释掉
      spData.list.forEach((item, index) => {
        if(!obj[item.name]){
          obj[item.name] = item
          localStorage.setItem('WebSocketData', JSON.stringify(obj))
          if (Object.keys(obj).length >0) {
            Bus.$emit("updateData", obj)
          }
        }
      })

      // 没用上
      // console.log(recvData.list)
      // const socketType = recvData.socketType
      // 判断回调函数是否存在
      // if (this.callBackMapping[socketType]) {
      //   const action = recvData.action
      //   if (action === 'getData') {
      //     const realData = JSON.parse(recvData.data)
      //     this.callBackMapping[socketType].call(this, realData)
      //   }
      // }
    }
  }
  // 把服务器的数据发送给页面
  getData (name, callBack) {
    // console.log(this.allData);
    // if(this.allData){
    //   // this.allData.forEach((item,index)=>{
    //   //   if(item.name ==name){
    //   //     callBack(item)
    //   //   }
    //   // })
    // }
  }
  // 回调函数的注册
  registerCallBack (socketType, callBack) {
    this.callBackMapping[socketType] = callBack
  }

  // 取消某一个回调函数
  unRegisterCallBack (socketType) {
    this.callBackMapping[socketType] = null
  }

  // 发送数据的方法
  send (data) {
    // 判断此时此刻有没有连接成功
    if (this.connected) {
      this.sendRetryCount = 0
      this.ws.send(JSON.stringify(data))
    } else {
      this.sendRetryCount++
      setTimeout(() => {
        this.send(data)
      }, this.sendRetryCount * 500)
    }
  }

  // 测试
  test() {
      // 是否使用模拟数据
      let obj = {}
      if (localStorage.getItem('WebSocketData')) {
        obj =  JSON.parse(localStorage.getItem('WebSocketData'))
      }
      spData.list.forEach((item, index) => {
        if(!obj[item.name]){
          obj[item.name] = item
          localStorage.setItem('WebSocketData', JSON.stringify(obj))
          if (Object.keys(obj).length >0) {
            Bus.$emit("updateData", obj)
          }
        }
      })
  }
}
